module.exports = __webpack_public_path__ + "a8a10a3e/img/chevron-down-icon.5542f65c.svg";